export default [
  {
    name: 'course-id',
    path: 'teacher/:teacherId/courses/:id',
    component: () => import(/* webpackChunkName: "course-id" */ '@/views/Courses'),
    meta: {
      keepAlive: true
    }
  },
  {
    name: 'lesson-id',
    path: 'teacher/:teacherId/courses/:courseId/lesson/:id',
    component: () => import(/* webpackChunkName: "lesson-id" */ '@/views/Courses/Lesson'),
    meta: {
      keepAlive: false
    }
  }
]
